var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    {
      staticClass: "flex flex-wrap p-0 list-none tracking-wider",
      style: { color: _vm.color },
    },
    _vm._l(_vm.tags, function (tag) {
      return _c("li", { key: tag }, [
        _vm._v("\n        " + _vm._s(`#${tag}`) + "\n    "),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }